import type { FC } from 'react';

interface LoadingCircleProps {
  width?: number;
  height?: number;
}
const LoadingCircle: FC<LoadingCircleProps> = ({ width = 46, height = 45 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M45.5 22.5C45.5 34.9264 35.4264 45 23 45C10.5736 45 0.5 34.9264 0.5 22.5C0.5 10.0736 10.5736 0 23 0C35.4264 0 45.5 10.0736 45.5 22.5ZM7.51588 22.5C7.51588 31.0516 14.4484 37.9841 23 37.9841C31.5516 37.9841 38.4841 31.0516 38.4841 22.5C38.4841 13.9484 31.5516 7.01588 23 7.01588C14.4484 7.01588 7.51588 13.9484 7.51588 22.5Z"
        fill="#B4C2CB"
      />
      <path
        d="M41.9921 22.5C43.9294 22.5 45.5279 20.9201 45.2271 19.0062C44.9516 17.2538 44.4693 15.5361 43.7873 13.8896C42.6566 11.1598 40.9992 8.67942 38.9099 6.5901C36.8206 4.50078 34.3402 2.84344 31.6104 1.71271C29.9639 1.03072 28.2462 0.548361 26.4938 0.272909C24.5799 -0.0279268 23 1.57056 23 3.50794C23 5.44532 24.5902 6.97638 26.478 7.41155C27.3122 7.60383 28.1309 7.86541 28.9255 8.19454C30.8041 8.97269 32.5111 10.1132 33.9489 11.5511C35.3868 12.9889 36.5273 14.6959 37.3055 16.5745C37.6346 17.3691 37.8962 18.1878 38.0884 19.022C38.5236 20.9098 40.0547 22.5 41.9921 22.5Z"
        fill="#006DFF"
      />
    </svg>
  );
};
export default LoadingCircle;
